var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({ height: _vm.contentHeight + 'px' })},[_c('iframe',{ref:"iframe",attrs:{"id":"template-iframe","src":_vm.src,"frameborder":"0","width":"100%","height":"100%","scrolling":"yes"},on:{"load":_vm.loaded}})])}
var staticRenderFns = []

export { render, staticRenderFns }